import { Menu, rem } from "@mantine/core";
import { t } from "i18next";

import { validationDisplayData } from "#modules/quoteRequestLines/ValidateMenuItem";
import { useValidateCosting } from "#modules/quoteRequestLines/views/useValidateCosting";
import { Icon } from "#shared/icons/Icon";
import { Tooltip } from "#shared/view/designSystem/Tooltip";

type Props = {
  quoteRequestLineIds: string[];
  quoteRequestId?: string;
  disabled?: boolean;
};

export const BulkValidateMenuItem = ({
  quoteRequestLineIds,
  quoteRequestId,
  disabled = false,
}: Props) => {
  const { validateCostingBulk } = useValidateCosting(quoteRequestId);

  const handleBulkValidateCosting = async () => {
    validateCostingBulk(quoteRequestLineIds);
  };

  const isDisabled = disabled || quoteRequestLineIds.length === 0;
  const { validateIcon } = validationDisplayData(undefined);

  return (
    <Tooltip
      multiline
      w={250}
      label={t("quoteRequestLine.bulkValidateTooltip")}
      transitionProps={{ transition: "fade", duration: 400 }}
    >
      <Menu.Item
        disabled={isDisabled}
        leftSection={<Icon name={validateIcon} style={{ width: rem(14), height: rem(14) }} />}
        onClick={handleBulkValidateCosting}
      >
        {t("quoteRequestLine.actions.bulkValidate")}
      </Menu.Item>
    </Tooltip>
  );
};
